import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShareDocComponent } from './share-doc.component';
import { ApiService } from '../core/api/api.service';
import { Observable, Subscription, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../core/authentication/authentication.service';
import { ShellStateService } from '../shell-state.service';
import { ShareDocDetailsComponent } from '../share-doc-details/share-doc-details.component';
import { ShellEmittersService } from '../shell-emitters.service';
import { MatomoTracker } from 'ngx-matomo-client';
import { MessageBoxService } from '../shared/dialog/messagebox.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ShareDocService implements OnDestroy {

    public dialogShare: any;
    private statShareSubscription: Subscription | undefined;
    private afterClosedSubscription: Subscription | undefined;

    constructor(
        public dialog: MatDialog,
        private apiService: ApiService,
        private authenticationService: AuthenticationService,
        private shellStateService: ShellStateService,
        private shellEmittersService: ShellEmittersService,
        private tracker: MatomoTracker,
        private translateService: TranslateService,
        private messageBoxService: MessageBoxService
    ) {
    }

    public startSharing = new EventEmitter<string>();
    public onIdChange = new EventEmitter<{ uri: string, callback: any }>();
    public googleUri = '';
    public callbackShareGC: any = null;
    public canOpen = false;

    closeShareGC() {
        // add stat
        if (this.statShareSubscription) { this.statShareSubscription.unsubscribe(); }
        this.statShareSubscription = this.apiService.addCustomDocStat(this.shellStateService.gcShareMapId, 'STAT_SHARECLASSROOM', this.authenticationService.getUserEmail()).subscribe((data: any) => { });
        this.closeShareMap();
    }

    closeShareMap() {
        this.dialogShare.close();
    }

    ngOnDestroy() {
        if (this.statShareSubscription) { this.statShareSubscription.unsubscribe(); }
    }


    public canShareDoc(docId: string, email: string): Observable<boolean> {
        return this.checkShareData(docId, email);
    }

    private checkShareData(docId: string, email: string): Observable<boolean> {
        if (!docId) {
            this.canOpen = false;
            return of(false);
        }

        return this.apiService.getShareData(email, docId).pipe(
            map((data: any) => {
                this.canOpen = !!data?.shareData;
                return this.canOpen;
            })
        );
    }

    public showShareDocDialog(docId: string, docType: string, docName: string, googleId: string, showClassroom: boolean, /*showFacebook: boolean,*/ isShared: boolean, showOnlyQrCode: boolean) {
        this.canShareDoc(docId, this.authenticationService.getUserEmail()).subscribe((canShare: boolean) => {
            if (canShare) {
                this.shellStateService.gcShareMapId = docId;
                this.dialogShare = this.dialog.open(ShareDocComponent, { autoFocus: false, width: '700px', disableClose: true });
                this.dialogShare.componentInstance.docId = docId;
                this.dialogShare.componentInstance.docType = docType;
                this.dialogShare.componentInstance.docName = docName;
                this.dialogShare.componentInstance.showClassroom = showClassroom;
                this.dialogShare.componentInstance.showOnlyQrCode = showOnlyQrCode;
                this.dialogShare.componentInstance.isShared = isShared;
                this.dialogShare.componentInstance.googleId = googleId;
                if (this.afterClosedSubscription) { this.afterClosedSubscription.unsubscribe(); }
                this.afterClosedSubscription = this.dialogShare.afterClosed().subscribe(() => {
                    if (docId) {
                        this.shellEmittersService.refreshRecentSharing.emit(docId);

                        if (docType==='pdf'){
                            //MATOMO Pdf share pdf
                            try {
                                console.log('MATOMO event Pdf share pdf');
                                this.tracker.trackEvent('Pdf', 'Share Pdf', 'SharePdf');
                            } catch (e: any) {
                                console.error('matomo error ' + e.message);
                            }
                        }
                        if (docType==='editor'){
                            //MATOMO Editor share editor
                            try {
                                console.log('MATOMO event Editor share editor');
                                this.tracker.trackEvent('Editor', 'Share Editor', 'ShareEditor');
                            } catch (e: any) {
                                console.error('matomo error ' + e.message);
                            }
                        }
                    }
                });
            } else {
                this.messageBoxService.showTextMessage(
                this.messageBoxService.MODE_TYPE.OK,
                this.translateService.instant('WARNING'),
                this.translateService.instant('DOC_SHARE_WARNING')
            );
            } });
        }

    public showShareDetailsDialog(docId: string, docType: string, docName: string, created: Date, nViews: number, nCopies: number, nSharedPeople: number, publicShareType: string) {
        this.dialogShare = this.dialog.open(ShareDocDetailsComponent, { autoFocus: false, width: '600px', disableClose: true });
        this.dialogShare.componentInstance.docId = docId;
        this.dialogShare.componentInstance.docType = docType;
        this.dialogShare.componentInstance.docName = docName;
        this.dialogShare.componentInstance.created = created;
        this.dialogShare.componentInstance.nViews = nViews;
        this.dialogShare.componentInstance.nCopies = nCopies;
        this.dialogShare.componentInstance.nSharedPeople = nSharedPeople;
        this.dialogShare.componentInstance.publicShareType = publicShareType;
        if (this.afterClosedSubscription) { this.afterClosedSubscription.unsubscribe(); }
        this.afterClosedSubscription = this.dialogShare.afterClosed().subscribe(() => { });
    }

}
